import React from 'react';

import { useContactUsHandler } from '../../../hooks/useContactUsHandler';
import { OrganizationLinkBase, OrganizationLinkPressable } from '../components';
import { type Props } from '../OrganizationLink.types';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLinkContactUs = (props: Props) => {
  const { link, textStyle } = props;

  const { hasDynamicChat, handleContactUs } = useContactUsHandler('org-links'); // prettier-ignore

  // ─────────────────────────────────────────────────────────────────────

  if (hasDynamicChat) {
    return (
      <OrganizationLinkPressable link={link} onPress={handleContactUs} textStyle={textStyle} />
    );
  }

  return <OrganizationLinkBase link={link} textStyle={textStyle} />;
};
